// project manager page by ankita 25/1/2024

import React, { useState } from "react";
import Sidebar from "../Components/Sidebar";
import maftlal from "../assests/images/mafatlal 1.png";
import { Link } from "react-router-dom";


export default function ProjectManager() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    // Display a preview of the selected image
    const reader = new FileReader();
    reader.onloadend = () => {
      setFilePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };
  return (
    <Sidebar>
      <>
        <div className="bg-grey-300 p-3 lg:p-3 xl:p-3 2xl:p-6">
          <div className="bg-white h-[78.55vh]" style={{ borderRadius: '0px 0px 11px 11px' }}>
            <div className="flex items-center bg-white px-4 py-3 lg:py-2 xl:py-3 2xl:py-3">
              {/* for project manager */}
              <div className="flex-1">
                <div className="flex justify-between lg:w-full px-10 lg:px-1  ">
                  <div className="flex ">
                    <div
                      className=" flex justify-center items-center border rounded-md border-white cursor-pointer">
                      <div className='text-4lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-bold'><p>Project Manager</p></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* for add project */}
              <div className="flex-1 ">
                <div className="flex justify-end">
                  <Link to="/editProjectManager">
                    <div
                      style={{ background: 'radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)' }}
                      className="py-1 lg:w-fit px-2  2xl:px-3 cursor-pointer  flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] ">
                      <div className='text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold'>  <p>Add Project</p></div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            {/* hr line  */}
            <hr
              style={{
                border: "1px solid rgba(205, 205, 205, 1)",
                // marginTop: "10px",
              }}
            />
            {/* maftlal image div */}
            <div className="w-full flex flex-row items-center p-6">
              <p className="px-5 font-semibold 2xl:text-4xl ">1.</p>
              <div className="flex items-center pl-[48px] ">
                <img
                  src={maftlal}
                  alt="maftlal"
                  className="object-cover lg:w-[60px] xl:w-[100px] 2xl:w-[180px]"
                />
              </div>
              <p className="px-[55px] font-semibold 2xl:text-4xl">Mafatlal App</p>
              <p className="ml-auto font-semibold pr-8 2xl:text-3xl">
                User Limit :{" "}
              </p>
              <p className="font-semibold w-[100px] text-center 2xl:text-3xl">
                999
                <hr
                  className="w-[100px]"
                  style={{
                    border: "1px solid rgba(205, 205, 205, 1)",
                  }}
                />
              </p>
              <div className="flex justify-end  pl-8 ">
                <div
                  style={{
                    background:
                      "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                  }}
                  className=" lg:w-fit px-4 py-1  2xl:px-3 cursor-pointer  flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px]  "
                >
                  <div className="text-4lg 2xl:text-3xl 2xl:pb-2 font-semibold">
                    <p>Apply</p>
                  </div>
                </div>
              </div>
            </div>
            {/* hr line */}
            <hr
              style={{
                border: "1px solid rgba(205, 205, 205, 1)",
              }}
            />
            {/* select project folder */}
            <div className="flex justify-center items-center w-full h-[263px] text-gray-400 ">
              <div className="text-xl 2xl:text-4xl font-semibold cursor-pointer">
                {/* Display the selected file name and preview */}
                {selectedFile ? (
                  <div>
                    <br />
                    Selected File: {selectedFile.name}
                    {filePreview && (
                      <img
                        src={filePreview}
                        alt="Selected File Preview"
                        className="w-[150px] h-[150px]"
                      />
                    )}
                  </div>
                ) : (
                  ""
                )}
                {/* Input type file for selecting files */}
                <input
                  type="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                  id="fileInput"
                />
                {/* Label to trigger the file input */}
                <label
                  htmlFor="fileInput"
                  onDoubleClick={() =>
                    document.getElementById("fileInput").click()
                  }
                >
                  Double Click to open Project Folder
                </label>
              </div>
            </div>
          </div>
        </div>
      </>
    </Sidebar>
  );
}